import { createContext } from 'react';
import UserDetails from '../../common/model/UserDetails';

export const userContext = createContext({user:new UserDetails,setUserDetails:(data:UserDetails)=>{}});